import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CaminhoEntrada, CategoriaWizard, PlataformaImportacao, ProdutoWizard} from '../../wizard-state.model';
import {ImportadorIfoodService} from '../../../../services/importador-ifood.service';

interface Plataforma {
  id: PlataformaImportacao;
  nome: string;
  logo: string;
  placeholder: string;
}

interface OpcaoCaminho {
  id: CaminhoEntrada;
  icone: string;
  titulo: string;
  descricao: string;
  badge: string | null;
}

@Component({
  selector: 'app-step-caminho-entrada',
  templateUrl: './step-caminho-entrada.component.html',
  styleUrls: ['./step-caminho-entrada.component.scss']
})
export class StepCaminhoEntradaComponent {
  @Input() empresa: any = {};
  @Input() fase: string = 'caminho-entrada';
  @Output() onVoltar = new EventEmitter<void>();
  @Output() onAvancar = new EventEmitter<void>();
  @Output() onEscolhido = new EventEmitter<CaminhoEntrada>();
  @Output() onImportacaoConcluida = new EventEmitter<{produtos: ProdutoWizard[]; categorias: CategoriaWizard[]; logo?: string; capa?: string; nomeEmpresa?: string | null; telefone?: string; enderecoImportado?: string; latitudeLongitude?: string}>();
  @ViewChild('linkInput') linkInput: ElementRef;
  plataformaSelecionada: PlataformaImportacao | null = null;
  selecaoLocal: CaminhoEntrada | null = null;
  url = '';
  importando = false;
  erro: string | null = null;
  erroValidacao: string | null = null;
  shakePlataformas = false;
  shakeCaminhos = false;
  shakeCampoLink = false;

  plataformas: Plataforma[] = [
    {id: 'anotaai', nome: 'Anota Aí', logo: 'assets/icons/logo-anotaai.png', placeholder: 'Cole o link da sua loja no Anota Aí'},
    {id: 'cardapioweb', nome: 'Cardápio Web', logo: 'assets/icons/logo-cardapioweb.png', placeholder: 'Cole o link da sua loja'},
    {id: 'cardapioai', nome: 'Cardapio.ai', logo: 'https://cardapio.ai/favicon.ico', placeholder: 'Cole o link da sua loja no Cardapio.ai'},
    {id: 'olaclick', nome: 'OlaClick', logo: 'assets/icons/logo-olaclick.png', placeholder: 'Cole o link da sua loja no OlaClick'},
    {id: 'goomer', nome: 'Goomer', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqxCSPYYW6j5QPSNa9lnLosO2VORnhRt0Lf3MvkZ2Kjw&s=10', placeholder: 'Cole o link da sua loja no Goomer'},
    {id: 'uairango', nome: 'UaiRango', logo: 'https://www.uairango.com/favicon.ico', placeholder: 'Cole o link da sua loja no UaiRango'},
    {id: 'aiqfome', nome: 'Aiqfome', logo: 'assets/icons/logo-aiqfome.png', placeholder: 'Cole o link da sua loja no Aiqfome'},
    {id: 'instadelivery', nome: 'InstaDelivery', logo: 'assets/icons/logo-instadelivery.png', placeholder: 'Cole o link da sua loja no InstaDelivery'},
    {id: 'menudino', nome: 'MenuDino', logo: 'assets/icons/logo-menudino.png', placeholder: 'Cole o link da sua loja no MenuDino'},
    {id: 'deliverydireto', nome: 'Delivery Direto', logo: 'https://deliverydireto.com.br/img/logo-delivery-direto-fundo-claro-1.png', placeholder: 'Cole o link da sua loja no Delivery Direto'},
    {id: 'takeat', nome: 'Takeat', logo: 'https://pedido.takeat.app/favicon.ico', placeholder: 'Cole o link da sua loja no Takeat'}
  ];

  readonly PLATAFORMA_IFOOD: Plataforma = {
    id: 'ifood', nome: 'iFood', logo: 'assets/icons/logo-ifood.png', placeholder: 'Cole o link da sua loja no iFood'
  };

  opcoesCaminho: OpcaoCaminho[] = [
    {
      id: 'template',
      icone: 'fe-layers',
      titulo: 'Criar produtos exemplo',
      descricao: 'Criamos uma base com categorias e produtos de exemplo. Você edita depois.',
      badge: null
    },
    {
      id: 'planilha',
      icone: 'fe-file-text',
      titulo: 'Importar de planilha',
      descricao: 'Envie uma planilha (.xlsx ou .csv) com seus produtos e categorias.',
      badge: null
    },
    {
      id: 'zero',
      icone: 'fe-edit-3',
      titulo: 'Criar do zero',
      descricao: 'Monte seu cardápio manualmente. Ideal para quem quer configurar tudo.',
      badge: null
    }
  ];

  constructor(private importadorService: ImportadorIfoodService) {}

  prosseguir() {
    if (!this.plataformaSelecionada) {
      this.shakePlataformas = true;
      setTimeout(() => this.shakePlataformas = false, 600);
      this.erroValidacao = 'Selecione uma plataforma para continuar.';
      return;
    }
    if (!this.url.trim()) {
      this.shakeCampoLink = true;
      setTimeout(() => this.shakeCampoLink = false, 600);
      this.erroValidacao = 'Informe o link da sua loja para importar o cardápio.';
      this.linkInput?.nativeElement?.focus();
      return;
    }
    this.erroValidacao = null;
    this.importar();
  }

  selecionarPlataforma(plataforma: PlataformaImportacao) {
    this.plataformaSelecionada = plataforma;
    this.url = '';
    this.erro = null;
    this.erroValidacao = null;
    setTimeout(() => this.linkInput?.nativeElement?.focus(), 0);
  }

  nenhumSistema() {
    this.plataformaSelecionada = null;
    this.url = '';
    this.erro = null;
    this.erroValidacao = null;
    this.onAvancar.emit();
  }

  confirmaIfood(temIfood: boolean) {
    if (temIfood) {
      this.plataformaSelecionada = this.PLATAFORMA_IFOOD.id;
      this.url = '';
      this.erro = null;
      this.erroValidacao = null;
      setTimeout(() => this.linkInput?.nativeElement?.focus(), 0);
    } else {
      this.erroValidacao = null;
      this.onAvancar.emit();
    }
  }

  recusaIfood() {
    this.plataformaSelecionada = null;
    this.url = '';
    this.erro = null;
  }

  voltarParaSistemas() {
    this.plataformaSelecionada = null;
    this.url = '';
    this.erroValidacao = null;
    this.onVoltar.emit();
  }

  voltarParaIfoodPergunta() {
    this.plataformaSelecionada = null;
    this.url = '';
    this.selecaoLocal = null;
    this.erroValidacao = null;
    this.onVoltar.emit();
  }

  escolher(caminho: CaminhoEntrada) {
    this.selecaoLocal = caminho;
    this.erroValidacao = null;
  }

  confirmar() {
    if (!this.selecaoLocal) {
      this.erroValidacao = 'Selecione como deseja começar.';
      this.shakeCaminhos = true;
      setTimeout(() => this.shakeCaminhos = false, 600);
      return;
    }
    this.erroValidacao = null;
    this.onEscolhido.emit(this.selecaoLocal);
  }

  get placeholderAtual(): string {
    if (this.plataformaSelecionada === 'ifood') return this.PLATAFORMA_IFOOD.placeholder;
    const p = this.plataformas.find(pl => pl.id === this.plataformaSelecionada);
    return p ? p.placeholder : '';
  }

  get podeImportar(): boolean {
    return !!this.plataformaSelecionada && !!this.url.trim();
  }

  importar() {
    if (!this.url.trim() || !this.plataformaSelecionada) return;

    this.importando = true;
    this.erro = null;

    let promise: Promise<any>;

    switch (this.plataformaSelecionada) {
      case 'ifood':
        promise = this.importadorService.listeNovosProdutosIfood(this.url, -1);
        break;
      case 'anotaai':
        const slug = this.importadorService.extraiaSlugLojaAnota(this.url);
        promise = this.importadorService.listeNovosProdutosAnotaAi(slug || this.url, -1);
        break;
      case 'cardapioweb':
        promise = this.importadorService.listeNovosProdutosCardapioWeb(this.url, -1);
        break;
      case 'cardapioai':
        promise = this.importadorService.listeNovosProdutosCardapioAi(this.url, -1);
        break;
      case 'olaclick':
        promise = this.importadorService.listeNovosProdutosOlaclick(this.url, -1);
        break;
      case 'goomer':
        promise = this.importadorService.listeNovosProdutosGoomer(this.url, -1);
        break;
      case 'uairango':
        promise = this.importadorService.listeNovosProdutosUaiRango(this.url, -1);
        break;
      case 'aiqfome':
        promise = this.importadorService.listeNovosProdutosAiqFome(this.url, -1);
        break;
      case 'instadelivery':
        promise = this.importadorService.listeNovosProdutosInstaDelivery(this.url, -1);
        break;
      case 'menudino':
        promise = this.importadorService.listeNovosProdutosMenuDino(this.url, -1);
        break;
      case 'deliverydireto':
        promise = this.importadorService.listeNovosProdutosDeliveryDireto(this.url, -1);
        break;
      case 'takeat':
        promise = this.importadorService.listeNovosProdutosTakeat(this.url, -1);
        break;
      default:
        return;
    }

    promise.then((resp: any) => {
      this.importando = false;
      const produtos = this.converterProdutos(resp);
      const categorias = this.agruparCategorias(produtos);
      const identidadeVisual = this.obtenhaIdentidadeVisual(resp);
      this.onImportacaoConcluida.emit({
        produtos,
        categorias,
        nomeEmpresa: this.obtenhaNomeEmpresa(resp),
        ...identidadeVisual,
        ...this.obtenhaEmpresaExtra(resp)
      });
    }).catch((err: any) => {
      this.importando = false;
      this.erro = err || 'Não foi possível importar. Verifique o link e tente novamente.';
    });
  }

  private converterProdutos(resp: any): ProdutoWizard[] {
    if (!resp) return [];
    const produtos = this.extraiaProdutos(resp);
    return produtos.map((p: any) => ({
      id: p.id || null,
      nome: p.nome || p.name || '',
      descricao: p.descricao || p.description || '',
      preco: p.preco || p.price || 0,
      imagem: p.imagem || p.image || p.linkImagem || null,
      categoria: this.normalizarCategoria(p),
      selecionado: true,
      salvo: !!p.id,
      exemplo: false,
      adicionais: p.adicionais || p.camposAdicionais || [],
      payload: p
    }));
  }

  private extraiaProdutos(resp: any): any[] {
    if (Array.isArray(resp)) return resp;
    if (Array.isArray(resp.novosProdutos)) return resp.novosProdutos;
    if (Array.isArray(resp.novos)) return resp.novos;
    if (Array.isArray(resp.produtos)) return resp.produtos;
    return [];
  }

  private normalizarCategoria(produto: any): string {
    const categoria = produto?.categoria;

    if (typeof categoria === 'string' && categoria.trim()) {
      return categoria;
    }

    if (categoria?.nome) {
      return categoria.nome;
    }

    if (produto?.nomeCategoria) {
      return produto.nomeCategoria;
    }

    return 'Importados';
  }

  private obtenhaIdentidadeVisual(resp: any): {logo?: string; capa?: string} {
    const empresaInfo = resp?.empresaInfo || {};

    return {
      logo: empresaInfo.logo || empresaInfo.imagem || undefined,
      capa: empresaInfo.capa || empresaInfo.banner || undefined
    };
  }

  private obtenhaNomeEmpresa(resp: any): string | null {
    return resp?.empresaInfo?.nome || null;
  }

  private obtenhaEmpresaExtra(resp: any): {telefone?: string; enderecoImportado?: string; latitudeLongitude?: string} {
    const info = resp?.empresaInfo || {};
    return {
      telefone: info.whatsapp || undefined,
      enderecoImportado: info.endereco || undefined,
      latitudeLongitude: info.latitudeLongitude || undefined
    };
  }

  private agruparCategorias(produtos: ProdutoWizard[]): CategoriaWizard[] {
    const map = new Map<string, ProdutoWizard[]>();
    produtos.forEach(p => {
      if (!map.has(p.categoria)) map.set(p.categoria, []);
      map.get(p.categoria).push(p);
    });
    return Array.from(map.entries()).map(([nome, prods]) => ({nome, produtos: prods}));
  }
}
